
import { Button, Form, Input, Modal, Popover } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formItemLayout } from '../../utils/antUtils';
import { cancelSblGroup, deleteSblGroup, editInput, saveSblgroup } from '../configActions';

const FormItem = Form.Item;

class ConfigSblGroupModalComponent extends Component {

  state = {
    confirmDeleteVisible: false
  }

  cancelDialog() {
    this.props.dispatch(cancelSblGroup());
  }

  submit() {

    this.props.form.validateFields((errors) => {
      if (errors) {
        return false;
      }

      this.props.dispatch(saveSblgroup(this.props.sblgroup));
    });
  }

  delete() {
    this.setState({ confirmDeleteVisible: false });
    this.props.dispatch(deleteSblGroup(this.props.sblgroup.id));
  }

  onChange(value, entity, attr) {
    this.props.dispatch(editInput({ value, entity, attr }));
  }

  render() {
    let confirmPopup = (<div>
      <Button onClick={() => this.delete()}>Ja</Button>
      <Button style={{ marginLeft: 10 }} onClick={() => this.setState({ confirmDeleteVisible: false })}>Nej</Button>
    </div>);

    const { getFieldDecorator } = this.props.form;

    let footer = this.props.sblgroup.new ? [] : [<div style={{ float: 'left' }}>
      <Popover visible={this.state.confirmDeleteVisible} placement="topLeft" title={'Är du säker?'} content={confirmPopup} trigger="click">
        <Button type="danger" onClick={() => this.setState({ confirmDeleteVisible: true })} >Radera</Button>
      </Popover>
    </div>];

    footer.push(<Button key="back" onClick={() => this.cancelDialog()}>Avbryt</Button>);
    footer.push(<Button key="submit" type="primary" onClick={() => this.submit()}>Spara</Button>);

    return (

      <Modal
        title='Ämnesområde'
        visible={this.props.sblgroup.show}
        onCancel={() => this.cancelDialog()}
        footer={footer}
        maskClosable={false}
      >
        <div>
          <Form onSubmit={this.handleSubmit}>
            <FormItem {...formItemLayout} label="Namn" >
              {getFieldDecorator('sblGroupName', { rules: [{ required: true, message: 'Ange ett namn' }], })(<Input onBlur={(e) => this.onChange(e.target.value, 'sblgroup', 'name')} />)}
            </FormItem>
            <FormItem {...formItemLayout} label="Database" >
              {getFieldDecorator('sblGroupDatabase', { rules: [{ required: true, message: 'Ange en databas' }], })(<Input onBlur={(e) => this.onChange(e.target.value, 'sblgroup', 'database')} />)}
            </FormItem>
          </Form>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  loading: state.config.loading,
  databases: state.config.databases,
  sblgroup: state.config.sblgroup
});

export default connect(mapStateToProps)(Form.create({
  mapPropsToFields(props) {

    return {
      sblGroupName: Form.createFormField({ value: props.sblgroup.name }),
      sblGroupDatabase: Form.createFormField({ value: props.sblgroup.database })
    }
  }
})(ConfigSblGroupModalComponent));


// WEBPACK FOOTER //
// ./src/config/dialogs/configSblGroupModalComponent.js